/* PB Showcase scroll engine.
   Countdown to release day + on-enter product reveal (spin-in + copy reveal).
   Each product scene fills exactly one screen (no tall runway), so there is no
   dead space; the product spins in as soon as its scene scrolls into view.
   Vanilla JS, IntersectionObserver, no scroll scrubbing. Honours reduced motion. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Countdown (runs regardless of motion preference) ---------- */

  function initCountdown(el) {
    var deadline = new Date(el.getAttribute('data-pb-deadline'));
    if (isNaN(deadline.getTime())) return;

    var cells = {
      d: el.querySelector('[data-pb-cd="d"]'),
      h: el.querySelector('[data-pb-cd="h"]'),
      m: el.querySelector('[data-pb-cd="m"]'),
      s: el.querySelector('[data-pb-cd="s"]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = deadline.getTime() - Date.now();
      if (left <= 0) {
        el.setAttribute('hidden', '');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      if (cells.d) cells.d.textContent = String(Math.floor(s / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (cells.s) cells.s.textContent = pad(s % 60);
    }

    tick();
    if (deadline.getTime() > Date.now()) el.removeAttribute('hidden');
    var timer = setInterval(tick, 1000);
  }

  /* ---------- Product scenes ---------- */

  function initScenes(root) {
    if (REDUCE.matches) return; // CSS shows everything statically

    root.classList.add('pb-sc--js');

    var spin = parseFloat(root.getAttribute('data-pb-spin'));
    if (isNaN(spin)) spin = 120;
    root.style.setProperty('--pb-spin-deg', spin + 'deg');

    var scenes = root.querySelectorAll('[data-pb-scene]');
    if (!scenes.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-on');
          } else if (entry.intersectionRatio === 0) {
            // Reset only when fully out, so it replays cleanly next time.
            entry.target.classList.remove('is-on');
          }
        });
      },
      { threshold: [0, 0.35] }
    );

    scenes.forEach(function (scene) { io.observe(scene); });
  }

  /* ---------- Boot ---------- */

  function boot() {
    document.querySelectorAll('[data-pb-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-pb-showcase]').forEach(initScenes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
